import { Component, OnInit } from "@angular/core";
import { CtrBaseComponent } from "../ctr-base.component";
import { PaymentService } from "app/payment/payment.service";
import { Router } from "@angular/router";
import { takeUntil } from "rxjs";
import { ConfirmPaymentAmountResponse } from "app/payment/payment";

@Component({
  ...CtrBaseComponent.metaData,
  selector: "app-ctr-payment-info",
  templateUrl: "./ctr-payment-info.component.html",
  styleUrls: ["./ctr-payment-info.component.scss"],
  standalone: false
})
export class CtrPaymentInfoComponent extends CtrBaseComponent implements OnInit {
  public paymentConfirmation: ConfirmPaymentAmountResponse;
  public currencySymbol: string = "";
  constructor(
    router: Router,
    private paymentService: PaymentService
  ) {
    super(router);
  }
  ngOnInit(): void {
    this.currencySymbol = this.dataSelects.packageOptions.currencySymbol.symbol;
    this.paymentService
      .getPaymentAmount(this.statement.id)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (response: ConfirmPaymentAmountResponse) => {
          this.paymentConfirmation = response;
        }
      });
  }
}
